import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconMediaPrevious = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M6 5.742c0-.203.07-.375.21-.515a.741.741 0 0 1 .54-.235c.203 0 .375.078.516.235.156.14.234.312.234.515v4.125l7.195-5.437c.672-.516 1.39-.586 2.157-.211.765.36 1.148.96 1.148 1.804v11.954c0 .843-.383 1.453-1.148 1.828-.766.36-1.485.28-2.157-.235L7.5 14.133v4.125a.741.741 0 0 1-.234.539.701.701 0 0 1-.516.21.782.782 0 0 1-.54-.21.782.782 0 0 1-.21-.54V5.743z" }),
});

export { IconMediaPrevious };
